import React, { useEffect } from 'react';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import Offerings from '../components/Offerings';
import FAQ from '../components/FAQ';
import { NextSeo } from 'next-seo';
import { getPageSeo } from '@/utils/seo';

const Home = ({ showAds }) => {
    const isClientSide = typeof window !== 'undefined';
    const seo = getPageSeo('home');
    
    useEffect(() => {
        if (isClientSide && showAds) {
            try {
                (window.adsbygoogle = window.adsbygoogle || []).push({});
            } catch (error) {
                console.error("AdSense error:", error);
            }
        }
    }, [isClientSide, showAds]);

    return (
        <>
            <NextSeo
                title={seo.title}
                description={seo.description}
                canonical={seo.canonical}
                openGraph={{
                    url: seo.canonical,
                    title: seo.title,
                    description: seo.description,
                    images: [
                        {
                            url: 'https://www.10-finger-schreiben-lernen.de/images/logo.png',
                            width: 1200,
                            height: 630,
                            alt: '10-Finger-Schreiben lernen',
                        },
                    ],
                }}
            />
            <Layout>
                <Hero />
                <Offerings />
                <FAQ />
                {showAds && (
                    <ins className="adsbygoogle"
                         style={{ display: 'block' }}
                         data-ad-client="ca-pub-9307288200117598"
                         data-ad-slot="9024056586"
                         data-ad-format="auto"
                         data-full-width-responsive="true">
                    </ins>
                )}
            </Layout>
        </>
    );
};

export default Home;
